import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout(): JSX.Element {
  return <Outlet />;
}
